<template>
  <div>
    <div v-if="device && selectedDevice" class="box-padding">
      <h1 class="device-name">
        <span class="uppercase brand-name">{{ brandName }}</span>
        {{ device.name }}</h1>

      <div class="mb-medium device-color-container">
        <!-- device color picker component -->
        <device-color
          :colors="device.tmaPoVariantOptions"
          position="left"
          variant="md"
          @click="emitChosenColor"
        />
      </div>

      <div class="flex main-condition">
        <div class="flex-1 flex">
          <h6
            class="uppercase text-center"
            @click="triggerPaymentMethod(false)"
            :class="{'active' : !instantPurchaseBool}"
          >{{ $t('pdp.with_contact') }}</h6>
        </div>
        <div class="flex-1 flex">
          <h6
            class="uppercase text-center"
            @click="triggerPaymentMethod(true)"
            :class="{'active' : instantPurchaseBool}"
          >{{ $t('pdp.without_contact') }}</h6>
        </div>
      </div>

      <div class="flex dropdowns">

        <!-- dropdown with label component -->
        <div class="dropdown-group flex-1">
          <label class="small-font small-font-margin">{{ $t('pdp.service') }}</label>
          <v-select class="select-dropdown device-info"
                    required
                    v-model="selectedTariffCategory"
                    :options="categories"
                    :disabled="instantPurchaseBool"
                    :searchable="false"
                    @input="changeTariffCategory"
                    label="name">
            <span slot="no-options">{{ selectedTariff }}</span>
          </v-select>
        </div>

        <!-- dropdown with label component -->
        <div class="dropdown-group flex-1">
          <label class="small-font small-font-margin">{{ $t('pdp.bundle') }}</label>
          <v-select class="select-dropdown device-info"
                    required
                    @input="changeTariff"
                    v-model="selectedTariff"
                    :options="tariffs"
                    :reduce="option => option.code"
                    :disabled="instantPurchaseBool"
                    :searchable="false"
                    label="name">
            <span slot="no-options">{{ selectedTariff }}</span>
          </v-select>
        </div>

      </div>

      <div v-if="selectedDevice" class="mb-default obligatory" :class="{'disabled' : instantPurchaseBool}">
        <span class="small-font">{{ $t('pdp.contact_commitment') }}</span>
        <span class="small-font-bold ml-default">{{ $t('pdp.contact_duration') }}</span>
      </div>

      <div class="flex mb-default scale-container">
        <div class="flex scale-container-div" :class="{'one-installment': cycleNumbers.length === 1}">
          <span class="small-font flex align-center">{{ $t('pdp.number_of_payments') }}</span>

          <span v-if="cycleNumbers.length === 1"
                class="one-only small-font-bold ml-default"
                :class="{'disabled' : instantPurchaseBool}">
            {{ cycleNumbers[0] }} {{ $t('pdp.installments') }}
          </span>
          <!-- base from-to component -->
          <div v-else class="from-to-scale-component-wrapper">
            <base-from-to-scale
              :disabled="disableScale || !cycleNumbers.length"
              :rangeOfNumbers="cycleNumbers"
              :selected="fullPaymentAtOnce ? selectedNumberOfMonths : selectedDevice.recurringChargeEntries[0].cycleEnd"
              @selectedNumber="applyMonths"
            />
          </div>
        </div>

        <!-- base checkbox component -->
        <base-round-checkbox
          :checked="checkbox"
          :disabled="!selectedDevice.subsidy"
          :autoCheck="instantPurchaseBool || checkAndDisable"
          :label="$t('pdp.pay_in_full_amount')"
          @checkboxBoolean="check(), applyCheckboxValue()"
        />

        <div v-if="selectedDevice.delayedPaymentPromotion && selectedDevice.delayedPromotionDescription"
             class="device-delayed-promotion-container">
          <DelayedPromotionStamp :month="selectedDevice.delayedPaymentPromotion"
                                 :description="selectedDevice.delayedPromotionDescription"/>
        </div>
      </div>
      <div class="separator-border"></div>
      <div class="flex result-box-container">

        <!-- device price box -->
        <div class="result-box">
          <base-result-box
            :label="$t('pdp.device')"
            :subLabel="fullPaymentAtOnce ? $t('pdp.once') : $t('pdp.monthly')"
            :price="
              fullPaymentAtOnce ?
              selectedDevice.oneTimeChargeEntries[0].price.formattedValue :
              selectedDevice.recurringChargeEntries[0].price.formattedValue"
            :oldPrice="hasOldPrice"
            :currency="
              fullPaymentAtOnce ?
              selectedDevice.oneTimeChargeEntries[0].price.currencyIso :
              selectedDevice.recurringChargeEntries[0].price.currencyIso"
            :preorder="$props.device.preorder"
          />
        </div>

        <!-- device tariff box -->
        <div v-if="!instantPurchaseBool" class="result-box">
          <base-result-box
            :label="$t('pdp.tariff')"
            :subLabel="$t('pdp.monthly_fee')"
            :price="selectedDevice.tariff.pricePlan.recurringChargeEntries[0].price.formattedValue"
            :oldPrice="selectedDevice.tariff.pricePlan.recurringChargeEntries[0].oldPrice !== undefined ?
                       selectedDevice.tariff.pricePlan.recurringChargeEntries[0].oldPrice.formattedValue : 0"
            :currency="selectedDevice.tariff.pricePlan.recurringChargeEntries[0].price.currencyIso"
            :tooltip="true"
          />
        </div>

      </div>
      <span v-if="device.esim" class="small-font esim">{{ $t('pdp.eSim_support') }}</span>
      <div class="device-info-footer">
        <device-pay-delivery-info/>
        <base-button v-if="reservationOnly"
                     variant="primary"
                     class="pdp-base-button"
                     @click="showReservationModal = true">
          {{ $t('pdp.reserve') }}
        </base-button>
        <base-button v-else
                     variant="primary"
                     class="pdp-base-button"
                     :disabled="disableAddToCart"
                     @click="addBundleToCart">
          {{ $t('pdp.add_to_cart') }}
        </base-button>
      </div>
    </div>
    <modal-replace-product :visible="!!replaceGroup.length"
                           :device-name="$props.device.name"
                           :tariff-name="tariffName"
                           :replace-group="productsForReplace"
                           :tariff-only="isTariffOnly"
                           @replace-product="replaceInCart"
                           @close="replaceGroup = []"/>
    <modal-reservation :visible="showReservationModal"
                       :value="reservationData"
                       :reservation-order-data="reservationOrderData"
                       :reservation-status="reservationStatus"
                       :loading="reservationLoading"
                       @reservation-valid="reservation"
                       @close="closeReservationModal"/>
  </div>
</template>

<script>
import BaseFromToScale from '@/components/base/base-from-to-scale'
import BaseButton from '@/components/base/base-button'
import BaseRoundCheckbox from '@/components/base/base-round-checkbox'
import BaseResultBox from '@/components/base/base-result-box'
import DevicePayDeliveryInfo from './device-pay-delivery-info'
import DelayedPromotionStamp from './device-delayed-promotion-stamp'
import { customEvent } from '@/services/customEventBus'
import DeviceColor from '@/components/common/device-color'
import ModalReplaceProduct from '@/components/common/modal/modal-replace/modal-replace-product'
import ModalReservation from '@/components/common/modal/modal-reservation'
import vSelect from 'vue-select'
import { getUrlParam, parseQueryString, makeQueryString } from '@/utils/urlMethods'
import { addProductToCart, replaceProductInCart } from '@/api/cart'
import { orderReservation } from '@/api/leadGeneration'
import { getCookie, setCookie, deleteCookie } from '@/utils/cookieController'
import { CART_EXPIRATION_DAYS, URL } from '@/config/constants'
import errorMessageHandler from '@/mixins/errorMessageHandler'
import { addDataLayerEvent } from '@/services/dataLayer'

export default {
  mixins: [errorMessageHandler],
  props: {
    device: {
      type: Object
    },
    segment: String
  },
  components: {
    BaseFromToScale,
    BaseButton,
    BaseRoundCheckbox,
    BaseResultBox,
    DevicePayDeliveryInfo,
    DeviceColor,
    DelayedPromotionStamp,
    ModalReplaceProduct,
    ModalReservation,
    vSelect
  },
  data () {
    return {
      selectedDevice: null,
      disableScale: false,
      fullPaymentAtOnce: false,
      selectedCategory: null,
      selectedNumberOfMonths: 24,
      cycleNumbers: [],
      instantPurchase: null,
      instantPurchaseBool: false,
      checkbox: false,
      urlTariff: '',
      variantCode: null,
      guid: null,
      replaceGroup: [],
      checkAndDisable: false,
      selectedTariff: '',
      selectedTariffCategory: '',
      reservationData: {
        name: '',
        email: '',
        phone: ''
      },
      showReservationModal: false,
      reservationStatus: null,
      reservationLoading: false,
      componentCreated: false,
      reservationOrderData: {}
    }
  },
  created () {
    this.selectedDevice =
      this.device.productOfferingPrices.find(i => i.tariff?.code === getUrlParam('tarifa') && i.recurringChargeEntries?.[0]?.cycleEnd === this.selectedNumberOfMonths) ||
      this.device.productOfferingPrices.find(each => each.automaticallyRecommended)
    this.initTriggerChanges(this.selectedDevice)
    this.generateCycleNumbers(this.selectedDevice.tariff.code)
    this.instantPurchase = this.device.productOfferingPrices.find(each => !each.tariff && each.oneTimeChargeEntries[0])
    this.urlTariff = getUrlParam('tarifa')
    this.variantCode = this.$props.device.tmaPoVariantOptions[0].code
    this.guid = getCookie('guid')
    customEvent.$on('choose-tariff', payload => {
      this.changeTariff(payload, false)
    })
    setTimeout(() => {
      customEvent.$emit('selected-tariff', this.selectedTariff, this.selectedTariffCategory, true)
      customEvent.$emit('disable-tariffs', this.instantPurchaseBool)
    }, 400)
    customEvent.$on('tab-change', () => {
      customEvent.$emit('selected-tariff', this.selectedTariff, this.selectedTariffCategory, true)
      customEvent.$emit('disable-tariffs', this.instantPurchaseBool)
    })
    this.productDetailsDataLayer()
    this.$nextTick(() => {
      this.componentCreated = true
    })
  },
  beforeDestroy () {
    customEvent.$off('tab-change')
    customEvent.$off('choose-tariff')
  },
  methods: {
    initTriggerChanges (param) {
      this.selectedCategory = this.selectedDevice
      this.selectedTariffCategory = param.tariff.categories[0].name
      this.selectedTariff = param.tariff.code
      if (param.recurringChargeEntries.length) {
        this.selectedNumberOfMonths = param.recurringChargeEntries[0].cycleEnd
        this.fullPaymentAtOnce = false
      } else {
        this.fullPaymentAtOnce = true
      }
    },

    findDevice () {
      this.selectedDevice = this.device.productOfferingPrices.find(each => each.tariff && each.recurringChargeEntries[0] && each.tariff?.code === this.selectedTariff && each.recurringChargeEntries?.[0]?.cycleEnd === this.selectedNumberOfMonths) ||
        this.device.productOfferingPrices.find(item => item.tariff && item.tariff.code === this.selectedTariff)
      this.initTriggerChanges(this.selectedDevice)
    },

    generateCycleNumbers (param) {
      this.cycleNumbers = []
      this.device.productOfferingPrices.forEach(each => {
        if (
          each.tariff &&
          each.tariff.code === param &&
          each.recurringChargeEntries[0] &&
          each.recurringChargeEntries[0].cycleEnd &&
          this.cycleNumbers.indexOf(each.recurringChargeEntries[0].cycleEnd) === -1
        ) {
          this.cycleNumbers.push(each.recurringChargeEntries[0].cycleEnd)
        }
      })
      this.cycleNumbers.sort((a, b) => a - b)
    },

    applyMonths (val) {
      this.selectedNumberOfMonths = val
      this.changeTariff(this.selectedTariff)
    },

    check () {
      this.checkbox = !this.checkbox
    },

    applyCheckboxValue () {
      this.disableScale = this.checkbox
      this.fullPaymentAtOnce = this.checkbox
      this.findInstantPaymentPackage(this.checkbox)
    },

    findInstantPaymentPackage (param) {
      if (param) {
        this.selectedDevice = this.device.productOfferingPrices.find(each => each.tariff && each.oneTimeChargeEntries[0] && each.tariff.code === this.selectedTariff)
      } else {
        this.findDevice()
      }
    },

    emitChosenColor (param) {
      customEvent.$emit('colorPicked', param)
      this.variantCode = param.code
    },

    triggerPaymentMethod (param) {
      customEvent.$emit('disable-tariffs', param)
      this.instantPurchaseBool = param
      if (this.instantPurchaseBool) {
        this.selectedDevice = this.instantPurchase
        this.disableScale = true
        this.fullPaymentAtOnce = true
      } else {
        this.applyCheckboxValue(this.checkbox)
      }
    },

    changeTariff (param, scroll = true) {
      const oldTariff = this.tariffName
      if (this.fullPaymentAtOnce) {
        this.cycleNumbers.forEach(i => {
          if (i === 24) {
            this.selectedNumberOfMonths = i
          } else {
            this.selectedNumberOfMonths = this.cycleNumbers[this.cycleNumbers.length - 1]
          }
        })
      }
      this.fullPaymentAtOnce = false
      customEvent.$emit('selected-tariff', param, this.selectedTariffCategory, scroll)
      let hasRecurring = false
      if (!this.fullPaymentAtOnce) {
        this.device.productOfferingPrices.forEach(each => {
          if (
            each.tariff &&
            each.tariff.code === param &&
            each.recurringChargeEntries[0] &&
            each.recurringChargeEntries[0].cycleEnd === this.selectedNumberOfMonths
          ) {
            this.selectedDevice = each
            this.initTriggerChanges(this.selectedDevice)
            this.disableScale = false
            this.checkbox = false
            this.checkAndDisable = false
            hasRecurring = true
          } else if (each.tariff && each.tariff.code === param && each.oneTimeChargeEntries[0] && !hasRecurring) {
            this.selectedDevice = each
            this.initTriggerChanges(this.selectedDevice)
            this.disableScale = true
            this.checkbox = true
            this.checkAndDisable = true
            hasRecurring = false
          }
        })
      } else {
        this.device.productOfferingPrices.forEach(each => {
          if (
            each.tariff &&
            each.tariff.code === param &&
            each.recurringChargeEntries[0] &&
            each.recurringChargeEntries[0].cycleEnd === this.selectedNumberOfMonths
          ) {
            this.checkAndDisable = false
            hasRecurring = true
          } else if (each.tariff && each.tariff.code === param && each.oneTimeChargeEntries[0] && !hasRecurring) {
            this.checkAndDisable = true
          }
          if (
            each.tariff &&
            each.tariff.code === param &&
            each.oneTimeChargeEntries[0]
          ) {
            this.selectedDevice = each
            this.selectedCategory = this.selectedDevice
            this.selectedTariff = this.selectedDevice.tariff.code
          }
        })
      }
      const existingQueryStrings = parseQueryString() ?? {}
      existingQueryStrings.tarifa = param
      const newQueryString = makeQueryString(existingQueryStrings)
      const baseUrl = window.location.origin + window.location.pathname
      const url = `${baseUrl}${newQueryString}`
      window.history.pushState({ path: url }, '', url)
      if (this.componentCreated) {
        this.changeTariffDataLayer('change tariff', oldTariff, this.tariffName)
      }
    },
    changeTariffCategory () {
      this.selectedTariff = this.tariffs[0].code
      this.changeTariff(this.selectedTariff)
    },
    addBundleToCart () {
      if (this.disableAddToCart) return
      if (this.$props.segment === 'POSLOVNI') {
        window.location.href = `${URL.businessPurchase}?pricePlanId=${this.selectedDevice.id}&variantProductCode=${this.variantCode}`
      } else {
        this.$loader.show()
        const data = {
          cartId: this.guid || 'new',
          pricePlanId: this.selectedDevice.id,
          variantProductCode: this.variantCode
        }
        addProductToCart(data).then(({ data }) => {
          setCookie('guid', data.cartGuid, CART_EXPIRATION_DAYS)
          this.guid = data.cartGuid
          this.addToCartDataLayer()
          if (data.cartModificationList.cartModifications?.[0].statusCode === 'success') {
            this.$globalEvent.$emit('device-added', data, 'add')
          } else if (data.cartModificationList.cartModifications?.[0].statusCode === 'productsNeedReplace') {
            this.replaceGroup = data.cartModificationList.cartModifications?.[0].replaceEntriesGroups
          }
        }).catch(e => {
          this.handleErrorMessage(e.response.data)
          if (e.response?.data?.errors?.[0].reason === 'notFound') {
            deleteCookie('guid')
            this.guid = ''
          }
        }).finally(() => {
          this.$loader.hide()
        })
      }
    },
    replaceInCart (entry) {
      const oldTariff = this.productsForReplace.find(i => i.productOfferingType === 'TARIFF')?.product?.name
      this.$loader.show()
      const dataToSend = {
        cartId: this.guid,
        entryNumbersDto: {
          entryNumbers: [entry]
        },
        pricePlanId: this.selectedDevice.id,
        variantProductCode: this.variantCode
      }
      replaceProductInCart(dataToSend).then(({ data }) => {
        this.$globalEvent.$emit('device-added', data, 'replace')
        if (oldTariff && this.tariffName) {
          this.changeTariffDataLayer('change tariff success', oldTariff, this.tariffName)
        }
      }).catch(e => {
        this.handleErrorMessage(e.response.data)
        if (e.response?.data?.errors?.[0].reason === 'notFound') {
          this.guid = ''
        }
      }).finally(() => {
        this.$loader.hide()
        this.replaceGroup = []
      })
    },
    reservation () {
      this.reservationLoading = true
      const normalizePhone = this.reservationData.phone.replace(/[^0-9]/g, '')
      const dataToSend = {
        address: {
          firstName: this.reservationData.name,
          email: this.reservationData.email,
          phone: normalizePhone
        },
        pricePlanId: this.selectedDevice.id,
        variantProductCode: this.variantCode,
        business: this.$props.segment === 'POSLOVNI'
      }
      orderReservation(dataToSend).then(res => {
        if (res.status >= 200 && res.status < 400) {
          this.reservationStatus = 'success'
          this.reservationOrderData.entries = res.data.cartModifications.map(item => item.entry)
        }
      }).catch(() => {
        this.reservationStatus = 'failed'
      }).finally(() => {
        Object.keys(this.reservationData).forEach(key => {
          this.reservationData[key] = ''
        })
        this.reservationLoading = false
      })
    },
    closeReservationModal () {
      this.showReservationModal = false
      this.reservationStatus = null
    },
    addToCartDataLayer () {
      let recPrice = this.selectedDevice?.recurringChargeEntries?.[0]?.price.value * this.selectedNumberOfMonths
      recPrice = recPrice.toString().replace('.', ',')
      let tariffPrice = this.selectedDevice?.tariff?.pricePlan?.recurringChargeEntries?.[0]?.price.value * this.selectedDevice?.tariff?.pricePlan?.recurringChargeEntries?.[0]?.cycleEnd
      tariffPrice = tariffPrice.toString().replace('.', ',')
      const tariff = {
        id: this.selectedDevice?.tariff?.code,
        name: this.selectedDevice?.tariff?.name,
        quantity: 1,
        price: tariffPrice
      }
      addDataLayerEvent({
        event: 'eec.add',
        ecommerce: {
          add: {
            actionField: {
              list: this.$props.device?.categories?.[0]?.name
            },
            products: [
              {
                id: this.$props.device.code,
                name: this.$props.device?.brands?.[0]?.name + ' ' + this.$props.device.name,
                category: this.$props.device?.categories?.[0]?.name,
                subcategory: this.$props.device?.categories?.[0]?.name,
                variant: this.$props.device?.tmaPoVariantOptions?.find(i => i.code === this.variantCode)?.variantOptionQualifiers?.[0]?.value,
                price: this.selectedDevice?.oneTimeChargeEntries?.[0]?.price.formattedValue || recPrice,
                quantity: 1
              },
              !this.instantPurchaseBool ? tariff : {}
            ]
          }
        }
      })
    },
    productDetailsDataLayer () {
      addDataLayerEvent({
        event: 'eec.detail',
        ecommerce: {
          detail: {
            actionField: {
              list: window.location.href
            },
            products: [{
              id: this.$props.device.code,
              name: this.$props.device?.brands?.[0]?.name + ' ' + this.$props.device.name,
              category: this.$props.device?.categories?.[0]?.name,
              subcategory: this.$props.device?.categories?.[0]?.name,
              variant: this.$props.device?.tmaPoVariantOptions?.find(i => i.code === this.variantCode)?.variantOptionQualifiers?.[0]?.value,
              price: this.selectedDevice?.tariff?.pricePlan?.recurringChargeEntries?.[0].price.formattedValue
            }]
          }
        }
      })
    },
    changeTariffDataLayer (eventName, oldTariff, newTariff) {
      addDataLayerEvent({
        event: eventName,
        'old tariff name': oldTariff,
        'new tariff name': newTariff
      })
    }
  },

  computed: {
    brandName () {
      return this.device.brands[0].name
    },
    categories () {
      const cat = []
      for (const each of this.device.productOfferingPrices) {
        if (each.tariff && cat.indexOf(each.tariff.categories[0].name) === -1) {
          cat.push(each.tariff.categories[0].name)
        }
      }
      return cat
    },
    tariffs () {
      const tariffArr = []
      this.device.productOfferingPrices.forEach(each => {
        if (each.tariff && each.tariff.categories[0].name === this.selectedTariffCategory) tariffArr.push(each.tariff)
      })

      const key = 'code'
      return [...new Map(tariffArr.map(item => [item[key], item])).values()]
    },
    hasOldPrice () {
      if (this.fullPaymentAtOnce) {
        return this.selectedDevice.oneTimeChargeEntries?.[0]?.oldPrice?.formattedValue
      }
      return this.selectedDevice.recurringChargeEntries?.[0]?.oldPrice?.formattedValue
    },
    productsForReplace () {
      const arr = []
      this.replaceGroup.forEach(entry => {
        entry.orderEntries.forEach(item => {
          arr.push(item)
        })
      })
      if (arr.filter(i => i.mandatoryForReplacement).length) {
        return arr.filter(i => i.mandatoryForReplacement)
      }
      return arr
    },
    isTariffOnly () {
      return this.productsForReplace.length === 1 && this.productsForReplace?.[0].productOfferingType === 'TARIFF'
    },
    tariffName () {
      if (this.selectedDevice?.tariff && this.isTariffOnly) {
        return `${this.$props.device.name} + ${this.selectedDevice.tariff.name}`
      } else if (this.selectedDevice?.tariff) {
        return this.selectedDevice.tariff.name
      }
      return ''
    },
    disableAddToCart () {
      return !this.selectedDevice.recurringChargeEntries.length && !this.selectedDevice.subsidy && !this.instantPurchaseBool
    },
    reservationOnly () {
      return !!this.$props.device.marketingTags.filter(i => i.code === 'prijavi_se_tag').length || this.$props.device.stock.stockLevelStatus === 'outOfStock'
    }
  },
  watch: {
    urlTariff () {
      if (this.urlTariff) {
        this.tariffs.forEach(tariff => {
          if (tariff.code === this.urlTariff) this.changeTariff(tariff.code)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.box-padding {
  padding: 25px 15px 30px;
  @media (#{map-get($breakpoints, sm)}) {
    padding: 35px 35px 40px;
  }

  @media (#{map-get($breakpoints, md)}) {
    padding: 40px 30px 30px;
  }

  @media (#{map-get($breakpoints, lg)}) {
    padding: 40px 50px 30px;
  }
}

h1 {
  color: $mtel-red;
}

.device-name {
  font-size: 22px;
  color: $mtel-red;
  margin-bottom: 25px;
  text-align: center;

  @media (map_get($breakpoints, sm)) {
    font-size: 36px;
  }

  @media (#{map-get($breakpoints, md)}) {
    text-align: left;
  }

  .brand-name {
    font-size: 18px;
    line-height: 1.3;
    font-weight: normal;
    color: $light-black;
    display: block;
    margin-bottom: 15px;

    @media (#{map-get($breakpoints, md)}) {
      font-weight: 600;
    }
  }
}

.device-color-wrapper {
  justify-content: center;

  @media (#{map-get($breakpoints, sm)}) {
    margin-bottom: 40px;
  }

  @media (#{map-get($breakpoints, md)}) {
    justify-content: flex-start;
    margin-bottom: 35px;
  }
}

.main-condition {
  h6 {
    width: 100%;
    color: $dark-grey;
    position: relative;
    padding: 0 0 10px;
    cursor: pointer;
    margin-bottom: 15px;
    padding-bottom: 8px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.71;

    @media (#{map-get($breakpoints, sm)}) {
      margin-bottom: 35px;
    }

    &:after {
      content: '';
      width: 100%;
      height: 2px;
      background-color: $form-border-color;
      position: absolute;
      left: 0;
      bottom: 0;
    }

    &.active {
      color: $mtel-red;

      &:after {
        background-color: $mtel-red;
      }
    }
  }
}

.ml-default {
  margin-left: 10px;
  color: $light-black;
}

.result-box {
  min-width: 110px;

  & + .result-box {
    margin-left: 50px;
  }
}

.dropdown-group {
  & + .dropdown-group {
    margin-left: 15px;
  }
}

.small-font {
  font-size: 1.4rem;
}

.small-font-margin {
  margin-bottom: 8px;
}

.obligatory {
  margin: 25px auto;
  width: fit-content;

  @media (#{map-get($breakpoints, sm)}) {
    margin-left: 0;
    margin-bottom: 10px;
  }

  @media (#{map-get($breakpoints, md)}) {
    margin-top: 30px;
  }

  &.disabled {
    .small-font-bold {
      color: $dark-grey;
    }
  }
}

.dropdowns {
  flex-wrap: wrap;

  @media (#{map-get($breakpoints, md)}) {
    flex-wrap: nowrap;
  }

  .dropdown-group {
    min-width: 100%;
    margin-left: 0;

    @media (#{map-get($breakpoints, md)}) {
      min-width: 0;
    }

    &:nth-child(1) {
      @media (#{map-get($breakpoints, md)}) {
        margin-right: 8px;
      }
    }

    &:nth-child(2) {
      margin-top: 15px;
      @media (#{map-get($breakpoints, md)}) {
        margin-top: 0;
        margin-left: 8px;
      }
    }
  }
}

.scale-container {
  position: relative;
  margin-bottom: 25px;
  flex-direction: column;

  @media (#{map-get($breakpoints, sm)}) {
    flex-direction: row;
    flex-wrap: nowrap;
    margin-bottom: 0px;
  }

  &-div {
    flex-direction: column;

    @media (#{map-get($breakpoints, sm)}) {
      flex-direction: row;
      width: fit-content;
      margin-right: 40px;
      align-items: center;
    }

    span {
      margin: auto;

      @media (#{map-get($breakpoints, sm)}) {
        width: fit-content;
        margin: 0;
      }
    }
  }

  .one-installment {
    flex-direction: row;
    justify-content: center;
    margin-bottom: 3rem;

    @media (#{map-get($breakpoints, sm)}) {
      margin-bottom: 0;
    }

    span:not(.one-only) {
      margin: 0;
    }

    .one-only {
      margin: 0 0 0 10px;
      @media (#{map-get($breakpoints, sm)}) {
        margin: 20px 0 20px 11px;
      }

      &.disabled {
        color: $dark-grey;
      }
    }

  }

  .from-to-scale-component-wrapper {
    width: 93%;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: 3%;

    @media (#{map-get($breakpoints, sm)}) {
      width: 150px;
      margin-bottom: 20px;
      margin-left: 30px;
    }
  }

  .checkbox-form {
    margin: auto;

    @media (#{map-get($breakpoints, sm)}) {
      margin: 0;
      width: fit-content;
    }
  }
}

.device-delayed-promotion-container {
  display: flex;
  justify-content: center;
  margin-top: 30px;
  @media (#{map-get($breakpoints, sm)}) {
    margin-left: auto;
    margin-top: 0;
  }
}

.result-box-container {
  flex-direction: column;

  @media (#{map-get($breakpoints, sm)}) {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: nowrap !important;
  }

  .result-box {
    margin: 0 auto 20px;

    @media (#{map-get($breakpoints, sm)}) {
      margin: 0 4rem 2rem 0;
      width: fit-content;
      justify-content: flex-start;
    }

    & > div {
      text-align: center;
    }
  }
}

.separator-border {
  height: 1px;
  margin-bottom: 25px;

  @media (#{map-get($breakpoints, md)}) {
    margin-bottom: 15px;
  }
}

.esim {
  display: block;
  margin: 0 auto 30px;
  width: fit-content;

  @media (map-get($breakpoints, sm)) {
    margin: 0 0 2.4rem;
  }

  + .device-info-footer {
    .pay-delivery-info {
      @media (map-get($breakpoints, sm)) {
        margin-bottom: 4.4rem;
      }

      @media (map-get($breakpoints, md)) {
        margin-bottom: 0;
      }
    }
  }
}

.pdp-base-button {
  width: 100%;

  @media (#{map-get($breakpoints, md)}) {
    max-width: 190px;
  }
}

.device-info-footer {
  position: relative;
}
</style>
